<div class="approved-container">
  <app-search-guides #searchGuides
                     class="block mt-48px"
                     [associatedInsiderId]="associatedInsiderId"
                     [status]="types.GuideStatus.Approved">
  </app-search-guides>
</div>
